/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
 document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // If the added node or its descendants match and have tabindex="0", strip it
        const candidates = node.matches('.accent-size-3, [tabindex="0"].product__grid--slides, [tabindex="0"].flickity-grid')
          ? [node]
          : [...node.querySelectorAll('[tabindex="0"].accent-size-3, [tabindex="0"].product__grid--slides, [tabindex="0"].flickity-grid')];

        candidates.forEach(el => {
          // double-check it's non-interactive before removing
          const role = el.getAttribute('role');
          if (!['button','link','checkbox','menuitem'].includes(role)) {
            el.removeAttribute('tabindex');
          }
        });
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also do an initial pass in case they're already present
  document.querySelectorAll('[tabindex="0"].accent-size-3, [tabindex="0"].product__grid--slides, [tabindex="0"].flickity-grid')
    .forEach(el => {
      const role = el.getAttribute('role');
      if (!['button','link','checkbox','menuitem'].includes(role)) {
        el.removeAttribute('tabindex');
      }
    });
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all divs inside the Flickity slider with tabindex
  setTimeout(function() {
    const nonInteractiveDivs = document.querySelectorAll('.accent-size-3');

    nonInteractiveDivs.forEach(function (el) {
      el.removeAttribute("tabindex");
    });
  }, 1000); 
});  

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


 /* document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });*/

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
